import client from './client';

export const activityApi = {
  // Get recent activity feed
  async list(params = {}) {
    const { data } = await client.get('/api/activity', { params });
    return data;
  },

  // Get activity for a specific task
  async getForTask(taskKey) {
    const { data } = await client.get(`/api/activity/task/${taskKey}`);
    return data;
  },
};
